export const changeDetection = {
    computed: {
        recurrenceIsDirty() {
            let recurrence = {};

            if (this.recurring) {
                recurrence = {
                    end_at: "",
                    interval: 0,
                    frequency: "",
                    days_of_week: [],
                };

                if (!this.recurrenceEndCustom && this.selectedContractEndDate) {
                    recurrence.end_at = this.moment(this.selectedContractEndDate)
                        .hour(23)
                        .minute(59)
                        .second(59)
                        .format("YYYY-MM-DD HH:mm:ss");
                } else {
                    recurrence.end_at = this.appointment.recurrence.end_at
                        ? this.moment(this.appointment.recurrence.end_at)
                              .hour(23)
                              .minute(59)
                              .second(59)
                              .format("YYYY-MM-DD HH:mm:ss")
                        : null;
                }

                const weekdays = ["MO", "TU", "WE", "TH", "FR", "SA"];
                recurrence.days_of_week = [];
                this.selectedDays.forEach((d, i) => {
                    if (d) {
                        recurrence.days_of_week.push(weekdays[i]);
                    }
                    switch (this.frequency) {
                        case "WEEKLY":
                            recurrence.interval = 1;
                            recurrence.frequency = "WEEKLY";
                            break;
                        case "WEEKLY2":
                            recurrence.interval = 2;
                            recurrence.frequency = "WEEKLY";
                            break;
                        case "MONTHLY":
                            recurrence.interval = 1;
                            break;
                    }
                });

                if (recurrence.days_of_week.length) {
                    recurrence.days_of_week = Array.from(new Set(recurrence.days_of_week));
                }
            }

            return (
                this.recurring &&
                JSON.stringify(recurrence) !== JSON.stringify(this.recurrenceClean)
            );
        },

        breakTimeIsDirty() {
            return this.breakTimeClean.enabled
                ? this.breakTimeClean.duration !== this.breakTime.duration ||
                      this.breakTimeClean.startTime !== this.breakTime.startTime
                : this.breakTime.enabled;
        },

        lunchTimeIsDirty() {
            return this.lunchTimeClean.enabled
                ? this.lunchTimeClean.duration !== this.lunchTime.duration ||
                      this.lunchTimeClean.startTime !== this.lunchTime.startTime
                : this.lunchTime.enabled;
        },

        appointmentIsDirty() {
            const appointmentBaseDataIsDirty =
                JSON.stringify(this.appointment) !== JSON.stringify(this.appointmentClean);
            return (
                this.appointment.id &&
                (appointmentBaseDataIsDirty ||
                    this.breakTimeIsDirty ||
                    this.lunchTimeIsDirty ||
                    this.recurrenceIsDirty)
            );
        },
    },
};
